import {
    CUSTOMER_ADDRESSES_LOADING, CUSTOMER_ADDRESSES_SUCCESS, CUSTOMER_ADDRESSES_ERROR,
    RESET_CUSTOMER_ADDRESSES
} from "../actions/actionCustomerAddresses";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "CustomerAddresses";

const initialState = {
    customerAddresses: loadState(sessionKey1, []),
    loading: false,
    customerAddressesError: ''
};

function reducerCustomerAddresses(state = initialState, action) {

    switch (action.type) {

        case CUSTOMER_ADDRESSES_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case CUSTOMER_ADDRESSES_SUCCESS: {

            saveState(sessionKey1, action.payload);

            return {
                ...state,
                loading: false,
                customerAddresses: action.payload,
                customerAddressesError: ''
            };
        }

        case CUSTOMER_ADDRESSES_ERROR: {

            saveState(sessionKey1, []);

            return {
                ...state,
                loading: false,
                customerAddresses: [],
                customerAddressesError: action.error
            }
        }

        case RESET_CUSTOMER_ADDRESSES: {

            saveState(sessionKey1, []);

            return {
                ...state,
                loading: false,
                customerAddresses: [],
                customerAddressesError: ''
            };
        }

        default: {
            return state;
        }
    }
}

export default reducerCustomerAddresses;